import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useNavigate, useLocation } from 'react-router-dom';
import PdfPreview from '../../../../Common/PDFPreview';
import { RingLoader } from 'react-spinners';
import { Typography } from '@mui/material';
import { FormaDateBalanceSheet } from "../../../../Common/FormatFunctions/FormatDate"
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
import PrintButton from '../../../../Common/Buttons/PrintPDF';

const apikey = process.env.REACT_APP_API;

const DispatchGradeWise = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');

    const companyCode = sessionStorage.getItem('Company_Code');
    const Year_Code = sessionStorage.getItem('Year_Code');
    const Company_Name = sessionStorage.getItem("Company_Name")
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [pdfPreview, setPdfPreview] = useState(null);

    const API_URL = `${apikey}/DispatchMillWise`;

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        fromDT: fromDate,
                        toDT: toDate,
                        Company_Code: companyCode,
                        Year_Code: Year_Code,
                    },
                });
                setReportData(response.data);
            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        if (fromDate && toDate) {
            fetchReportData();
        }
    }, [fromDate, toDate, companyCode, Year_Code]);

    const handlePrint = () => {
        const printContent = document.getElementById('reportTable').outerHTML;
        const win = window.open('', '', 'height=700,width=900');
        win.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        body {
                            font-family: Arial, sans-serif;
                            margin: 20px;
                        }
                        .company-name {
                            text-align: center;
                            font-size: 24px;
                            font-weight: bold;
                            margin-bottom: 20px;
                            color: #333;
                        }
                        table {
                            width: 100%;
                            border-collapse: collapse;
                            margin-bottom: 20px;
                        }
                        th, td {
                            border: 1px solid #ddd;
                            padding: 8px;
                            text-align: left;
                        }
                        th {
                            background-color: #f2f2f2;
                            font-weight: bold;
                        }
                        tr:nth-child(even) {
                            background-color: #f9f9f9;
                        }
                        .total-row {
                            background-color: #e0f7fa;
                            font-weight: bold;
                        }
                    </style>
                </head>
                <body>
                    <div class="company-name">${Company_Name}</div>
                    ${printContent}
                </body>
            </html>
        `);
        win.document.close();
        win.print();
    };

    const generatePdf = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const textWidth = doc.getTextWidth(Company_Name);
        const xPosition = (pageWidth - textWidth) / 2;

        doc.text(Company_Name, xPosition, 10);
        doc.autoTable({ html: '#reportTable' });

        const pdfBlob = doc.output('blob');
        const url = URL.createObjectURL(pdfBlob);
        setPdfPreview(url);
    };

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [];

        wsData.push([Company_Name]);
        wsData.push([]);

        wsData.push([
            'DoNo', 'Date', 'Qntl', 'Mill Rate', 'Amount', 'SaleRate',
            'PurchaseRate', 'TDSAmt', 'CGSTAmt', 'SGSTAmt', 'IGSTAmt',
            'BillAmt', 'NetPayableAmt'
        ]);

        Object.entries(groupedReportData).forEach(([key, { items }]) => {
            wsData.push([key]);

            let totalQty = 0, amount = 0, TDSamt = 0, CGSTAmt = 0, SGSTAmt = 0, IGSTAmt = 0, BIllAmt = 0, NetPayable = 0;

            items.forEach(item => {
                const qntl = parseFloat(item.quantal) || 0;
                const amt = parseFloat(item.amount) || 0;
                const tds = parseFloat(item.TDS_Amt) || 0;
                const cgst = parseFloat(item.CGSTAmount) || 0;
                const sgst = parseFloat(item.SGSTAmount) || 0;
                const igst = parseFloat(item.IGSTAmount) || 0;
                const bill = parseFloat(item.Bill_Amount) || 0;
                const net = parseFloat(item.TCS_Net_Payable) || 0;

                totalQty += qntl;
                amount += amt;
                TDSamt += tds;
                CGSTAmt += cgst;
                SGSTAmt += sgst;
                IGSTAmt += igst;
                BIllAmt += bill;
                NetPayable += net;

                wsData.push([
                    item.do_no,
                    item.do_date,
                    qntl,
                    item.millrate,
                    amt,
                    item.salerate,
                    item.PurchaseRate,
                    tds,
                    cgst,
                    sgst,
                    igst,
                    bill,
                    net,

                ]);
            });

            wsData.push([
                'Total',

                '',
                totalQty.toFixed(2),
                '',
                amount.toFixed(2),
                '',
                '',
                TDSamt.toFixed(2),
                CGSTAmt.toFixed(2),
                SGSTAmt.toFixed(2),
                IGSTAmt.toFixed(2),
                BIllAmt.toFixed(2),
                NetPayable.toFixed(2),

            ]);

            wsData.push([]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'DispatchGradeWise');
        XLSX.writeFile(wb, 'DispatchGradeWise.xlsx');
    };

    const groupReportData = (data) => {
        const grouped = {};
        data.forEach(item => {
            const key = `${item.purc_no}-${item.grade}`;
            if (!grouped[key]) {
                grouped[key] = { items: [] };
            }
            grouped[key].items.push(item);
        });
        return grouped;
    };

    const groupedReportData = groupReportData(reportData);

    return (
        <div style={{ marginTop: '-80px' }}>
            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography> */}

            <div className="d-flex justify-content-between align-items-center">
                <div style={{ flex: 1, textAlign: 'center',marginLeft:"280px"  }}>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Dispatch Grade Wise</Typography>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>
                </div>

                <div className="d-flex justify-content-end">
                    <PrintButton disabledFeild={""} fetchData={handlePrint} />
                    <button className="btn btn-success me-2" onClick={handleExportToExcel}>Export to Excel</button>
                    <button className="btn btn-secondary" onClick={generatePdf}>PDF</button>
                </div>
            </div>


            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <RingLoader />
                </div>
            ) : error ? (
                <div className="alert alert-danger">{error}</div>
            ) : (
                <div style={{ maxHeight: "800px", overflowY: "auto" }}>
                    <table className="table table-striped table-bordered mt-4" id="reportTable" style={{ marginBottom: "60px", width: "100%" }}>
                        <thead className="table-light" style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1, whiteSpace: "nowrap" }}>
                            <tr>
                                <th>Do No</th>
                                <th>Date</th>
                                <th>Quintal</th>
                                <th>Mill Rate</th>
                                <th>Amount</th>
                                <th>Sale Rate</th>
                                <th>Purchase Rate</th>
                                <th>TDS</th>
                                <th>CGST</th>
                                <th>SGST</th>
                                <th>IGST</th>
                                <th>Bill Amount</th>
                                <th>Net Payable Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedReportData).map(([key, { items }]) => {
                                const totalQty = items.reduce((sum, item) => sum + parseFloat(item.quantal || 0), 0);
                                const amount = items.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
                                const TDSamt = items.reduce((sum, item) => sum + parseFloat(item.TDS_Amt || 0), 0);
                                const CGSTAmt = items.reduce((sum, item) => sum + parseFloat(item.CGSTAmount || 0), 0);
                                const SGSTAmt = items.reduce((sum, item) => sum + parseFloat(item.SGSTAmount || 0), 0);
                                const IGSTAmt = items.reduce((sum, item) => sum + parseFloat(item.IGSTAmount || 0), 0);
                                const BIllAmt = items.reduce((sum, item) => sum + parseFloat(item.Bill_Amount || 0), 0);
                                const NetPayable = items.reduce((sum, item) => sum + parseFloat(item.TCS_Net_Payable || 0), 0);

                                return (
                                    <React.Fragment key={key}>
                                        <tr>
                                            <td colSpan={14} align="left" className="table-primary" style={{ color: 'blue', fontWeight: 'bold' }}>{key}</td>
                                        </tr>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ fontWeight: 'bold' }}>{item.do_no}</td>
                                                <td style={{ fontWeight: 'bold' }}>{item.do_date}</td>

                                                <td align="right">{formatReadableAmount(item.quantal)}</td>
                                                <td align="right">{formatReadableAmount(item.millrate)}</td>
                                                <td align="right" style={{ fontWeight: 'bold' }}>{formatReadableAmount(item.amount)}</td>
                                                <td align="right">{formatReadableAmount(item.salerate)}</td>
                                                <td align="right">{formatReadableAmount(item.PurchaseRate)}</td>
                                                <td align="right">{formatReadableAmount(item.TDS_Amt)}</td>
                                                <td align="right">{formatReadableAmount(item.CGSTAmount)}</td>
                                                <td align="right">{formatReadableAmount(item.SGSTAmount)}</td>
                                                <td align="right">{formatReadableAmount(item.IGSTAmount)}</td>
                                                <td align="right">{formatReadableAmount(item.Bill_Amount)}</td>
                                                <td align="right">{formatReadableAmount(item.TCS_Net_Payable)}</td>

                                            </tr>
                                        ))}
                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f8ff' }}>
                                            <td colSpan={2} align="right">Total </td>
                                            <td align="right">{formatReadableAmount(totalQty.toFixed(2))}</td>
                                            <td></td>
                                            <td align="right">{formatReadableAmount(amount.toFixed(2))}</td>
                                            <td></td>
                                            <td></td>
                                            <td align="right">{formatReadableAmount(TDSamt.toFixed(2))}</td>
                                            <td align="right">{formatReadableAmount(CGSTAmt.toFixed(2))}</td>
                                            <td align="right">{formatReadableAmount(SGSTAmt.toFixed(2))}</td>
                                            <td align="right">{formatReadableAmount(IGSTAmt.toFixed(2))}</td>
                                            <td align="right">{formatReadableAmount(BIllAmt.toFixed(2))}</td>
                                            <td align="right">{formatReadableAmount(NetPayable.toFixed(2))}</td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {pdfPreview && (
                <div className="centered-container">
                    <PdfPreview pdfData={pdfPreview} apiData={reportData} label={'NewDispatchRegister'} />
                </div>
            )}
        </div>
    );
};

export default DispatchGradeWise;